import { render } from "./Studydata.vue?vue&type=template&id=70c187b1&scoped=true"
import script from "./Studydata.vue?vue&type=script&lang=js"
export * from "./Studydata.vue?vue&type=script&lang=js"

import "./Studydata.vue?vue&type=style&index=0&id=70c187b1&scoped=true&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c187b1"]])

export default __exports__